import { FETCH_STEEL_SMELTER_REGIONS } from '../../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_STEEL_SMELTER_REGIONS:
			return action.payload;
		default:
			return state;
	}
};
